import { useQuery } from "@apollo/client";
import { IonContent } from "@ionic/react";
import { useCallback, useRef } from "react";
import { Helmet } from "react-helmet-async";
import { useIntl } from "react-intl";
import { useHistory } from "react-router";

import GoalTemplateForm from "@components/forms/GoalTemplateForm";
import HandleQuery from "@components/HandleQuery";
import AppPage from "@components/pageTypes/AppPage";
import { GetGoalTemplateDocument, GetGoalTemplateQuery, GetGoalTemplateQueryVariables } from "@typing/Generated";

type Props = {
  goalTemplateId: string;
};

const ExpertGoalTemplateEditPage = ({ goalTemplateId }: Props) => {
  const history = useHistory();
  const intl = useIntl();
  const contentRef = useRef<HTMLIonContentElement>(null);

  const getGoalTemplateQuery = useQuery<GetGoalTemplateQuery, GetGoalTemplateQueryVariables>(GetGoalTemplateDocument, {
    variables: { id: goalTemplateId }
  });

  const handleFormCancelOrSuccess = () => history.push("/expert/goal-templates");

  const handleFormError = useCallback(() => {
    if (contentRef.current) {
      contentRef.current.scrollToTop(2000);
    }
  }, [contentRef]);

  return (
    <AppPage>
      <Helmet>
        <title>{intl.formatMessage({ id: "pageTitles.expert.goalTemplate.edit" })}</title>
      </Helmet>
      <IonContent className="ion-padding" ref={contentRef}>
        <HandleQuery query={getGoalTemplateQuery}>
          {data => (
            <GoalTemplateForm
              autofocus
              goalTemplate={data.goalTemplate}
              onCancel={handleFormCancelOrSuccess}
              onError={handleFormError}
              onSuccess={handleFormCancelOrSuccess}
            />
          )}
        </HandleQuery>
      </IonContent>
    </AppPage>
  );
};

export default ExpertGoalTemplateEditPage;
